import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=886b1232&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('886b1232')) {
      api.createRecord('886b1232', component.options)
    } else {
      api.reload('886b1232', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=886b1232&", function () {
      api.rerender('886b1232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/Page.vue"
export default component.exports